import script from "./MetaDynamicForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MetaDynamicForm.vue?vue&type=script&setup=true&lang=js"

import "./MetaDynamicForm.vue?vue&type=style&index=0&id=034676fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-034676fc"]])

export default __exports__